import { render, staticRenderFns } from "./ExternalFrame.vue?vue&type=template&id=e068667e&scoped=true"
import script from "./ExternalFrame.vue?vue&type=script&lang=js"
export * from "./ExternalFrame.vue?vue&type=script&lang=js"
import style0 from "./ExternalFrame.vue?vue&type=style&index=0&id=e068667e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e068667e",
  null
  
)

export default component.exports